var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import requiredIf from "react-required-if";
import { linkLoud, linkDark, linkLight, linkDestructive, focusOutlineColor, focusOutlineStyle, focusOutlineWidth, focusOutlineOffset } from "@nib-components/theme";
export var validColorValues = ["loud", "dark", "light", "destructive"];
export var validIconPlacementValues = ["left", "right"]; // eslint-disable-next-line @typescript-eslint/no-unused-vars

export var IconAlignment = styled(function (_ref) {
  var iconPlacement = _ref.iconPlacement,
      props = _objectWithoutProperties(_ref, ["iconPlacement"]);

  return /*#__PURE__*/React.createElement("span", props);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  vertical-align: sub;\n\n  ", ";\n"])), function (_ref2) {
  var iconPlacement = _ref2.iconPlacement;
  return iconPlacement === "left" ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          margin-right: 0.5rem;\n        "]))) : css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          margin-left: 0.5rem;\n        "])));
});
export var BaseLink = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var Component = props.component,
      _props$color = props.color,
      color = _props$color === void 0 ? "loud" : _props$color,
      Icon = props.icon,
      iconPlacement = props.iconPlacement,
      underline = props.underline,
      children = props.children,
      otherProps = _objectWithoutProperties(props, ["component", "color", "icon", "iconPlacement", "underline", "children"]);

  return Icon ? /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, otherProps), iconPlacement === "left" && /*#__PURE__*/React.createElement(IconAlignment, {
    iconPlacement: iconPlacement
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "xs",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("span", null, children), iconPlacement === "right" && /*#__PURE__*/React.createElement(IconAlignment, {
    iconPlacement: iconPlacement
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "xs",
    fill: "currentColor"
  }))) : /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, otherProps), children);
});
BaseLink.defaultProps = {
  component: "a"
};
var loudLink = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), linkLoud);
var darkLink = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), linkDark);
var lightLink = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), linkLight);
var destructiveLink = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), linkDestructive);
var Link = styled(BaseLink)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  text-decoration: underline;\n  text-underline-offset: 0.125em; /* 2px at 16px */\n  text-decoration-thickness: min(0.125em, 4px); /* 2px at 16px */\n\n  /* Handle long links (like urls) */\n  /* These are technically the same, but use both */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n\n  -ms-word-break: break-all;\n  /* This is the dangerous one in WebKit, as it breaks things wherever */\n  word-break: break-all;\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n\n  /* Subtly more weight for links, defaults to 400 font weight if 500 is not available for a brand */\n  font-weight: 500;\n\n  /* By default, use the loudLink */\n  ", ";\n\n  /* Otherwise we set the color to one of these three */\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", "\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: ", ";\n  }\n"])), function (_ref3) {
  var color = _ref3.color;
  return !validColorValues.includes(color) && loudLink;
}, function (_ref4) {
  var color = _ref4.color;
  return color === "loud" && loudLink;
}, function (_ref5) {
  var color = _ref5.color;
  return color === "dark" && darkLink;
}, function (_ref6) {
  var color = _ref6.color;
  return color === "light" && lightLink;
}, function (_ref7) {
  var color = _ref7.color;
  return color === "destructive" && destructiveLink;
}, function (_ref8) {
  var underline = _ref8.underline;
  return !underline && "text-decoration: none;";
}, focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineOffset);
Link.propTypes = {
  color: PropTypes.oneOf(validColorValues),
  underline: PropTypes.bool,
  icon: PropTypes.func,
  iconPlacement: PropTypes.oneOf(validIconPlacementValues)
};
Link.defaultProps = {
  color: "loud",
  iconPlacement: "right",
  underline: true
};
Link.displayName = "Link";
export default Link;